import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets.app/images/tutorial-save.svg'
import _imports_1 from '@/assets.app/images/tutorial-favorite.svg'


const _hoisted_1 = { class: "tutorial__item" }
const _hoisted_2 = { class: "tutorial__image-box" }
const _hoisted_3 = {
  key: 0,
  class: "tutorial__image",
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  class: "tutorial__image",
  src: _imports_1,
  alt: ""
}
const _hoisted_5 = { class: "tutorial__text-box" }
const _hoisted_6 = { class: "tutorial__btn-box" }

import { computed } from 'vue'
import { BookTutorial, BookTutorialStep } from '@/models/doc.tutorial'
import { saveForLater20321Treatment } from '@/services/ab/experiments'


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarTutorialStepFavorite',
  props: {
    bookTutorial: {}
  },
  setup(__props: any) {

const props = __props

const isActive = computed(() => {
  return props.bookTutorial.step === BookTutorialStep.favorite
})

const showNewSaveDesign = computed(() => saveForLater20321Treatment())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (showNewSaveDesign.value)
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : (_openBlock(), _createElementBlock("img", _hoisted_4))
        ]),
        _createElementVNode("div", _hoisted_5, [
          (showNewSaveDesign.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "tutorial__title" }, "Save", -1)),
                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "tutorial__text" }, " Save to your Want to Read list or another reading list. You can find your reading lists in My Library. ", -1))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "tutorial__title" }, "Add to Favorite", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "tutorial__text" }, " Mark your favorite guides here. You can find your favorites on your homepage. ", -1))
              ], 64)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              class: "tutorial__btn btns",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.bookTutorial.incrementStep()))
            }, [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Next", -1),
              _createElementVNode("span", { class: "tutorial__btn-arr iconfont inext" }, null, -1)
            ]))])
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("ul", { class: "tutorial__dots" }, [
            _createElementVNode("li", { class: "tutorial__dot" }),
            _createElementVNode("li", { class: "tutorial__dot" }),
            _createElementVNode("li", { class: "tutorial__dot" }),
            _createElementVNode("li", { class: "tutorial__dot" }),
            _createElementVNode("li", { class: "tutorial__dot" })
          ], -1))
        ])
      ], 512), [
        [_vShow, isActive.value]
      ])
    ]),
    _: 1
  }))
}
}

})